import Api from "../api";
let uri = '/api/ed/microaprendizaje';

export const getMicroaprendizajes = (data) => {
    return Api.getInstance().executeQuery(`${uri}/list`, data)
    .then((resp) => resp.data)
    .catch((error) =>
        console.log(error)
    );
}

export const getContenidoMicroaprendizajes = (data) => {
    return Api.getInstance().executeQuery(`${uri}/contenido/list`, data)
    .then((resp) => resp.data)
    .catch((error) =>
        console.log(error)
    );
}

export const adminMicroaprendizajes = (data) => {
    return Api.getInstance().executeQuery(`${uri}`, data)
    .then((resp) => resp)
    .catch((error) =>
        console.log(error)
    );
}

export const adminContenidoMicroaprendizajes = (data) => {
    return Api.getInstance().executeQuery(`${uri}/contenido`, data)
    .then((resp) => resp)
    .catch((error) =>
        console.log(error)
    );
}



